<template>
    <div>
        <div v-for="(optionalExtrasWithinCategory, optionalExtrasCategory) in optionalExtras" :key="optionalExtrasCategory + '.optionalExtras'">
            <ul class="reuseable-faq__ul">
                <li class="reuseable-faq__li">
                    <button type="button" @click="selectCategory(optionalExtrasCategory)" class="reuseable-faq__item reuseable-faq__toggle" :aria-expanded="optionCategorySelected == optionalExtrasCategory">
                        <h3 class="reuseable-faq__title" v-html="optionalExtrasCategory" />
                        <img src="/images/link-icon.svg" class="reuseable-faq__toggle-icon" :class="{'reuseable-faq__toggle-icon--in': optionCategorySelected == optionalExtrasCategory }" />
                    </button>

                    <CollapseTransition>
                        <div v-show="optionCategorySelected == optionalExtrasCategory" class="reuseable-faq__content new-details__spec-item-container">
                            <div v-for="(specItem, index) in optionalExtrasWithinCategory" :key="'optionalExtra.' + index" class="new-details__spec-item">
                                <!-- <span class="new-details__spec-item-name">{{  }}</span> -->
                                <span class="new-details__spec-item-value" v-html="specItem"></span>
                            </div>
                        </div>
                    </CollapseTransition>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { CollapseTransition } from "vue2-transitions";

export default {
    components: {
        CollapseTransition,
    },
    data() {
        return {
            optionCategorySelected: null,
        };
    },
    methods: {
        selectCategory(categoryToSelect) {
            if (this.optionCategorySelected == categoryToSelect) {
                this.optionCategorySelected = null;
                return;
            }
            this.optionCategorySelected = categoryToSelect;
        }
    },
    computed: {
        ...mapState('NewVehicleData', ['standardSpec']),
        optionalExtras() {
            if (typeof this.standardSpec['Options'] == 'undefined') {
                return [];
            }
            return this.standardSpec['Options'];
        }
    },
    created() {
        this.optionCategorySelected = Object.keys(this.optionalExtras)[0];
    }
};
</script>

<style lang="scss">

</style>
